/* Tracking url used across classplus repos */
export const TrackEndPoint = "/analytics-api/v1/event/capture";
/* Tracking url for ingest used across classplus repos */
export const TrackEndPointIngest = "/analytics-api/v1/events/ingest";
/* User Session url used to get user session token */
export const UserSessionEndPoint = "/analytics-api/v1/session/token";
/* event limit which will trigger tracking once reached */
export const EventLimit = 1;
/* time limit which will trigger tracking once reached */
export const TimeLimit = 0;
/* max retry count */
export const MaxRetryCount = 3;
/* different environments */
export const envMap = {
  PRODUCTION: "production",
  PROD: "prod",
  PREPROD: "preprod",
  STAGING: "staging",
  QA: "qa",
};
export const COSMOS_USER_SESSION = 'COSMOS_USER_SESSION';